import { Card, Tabs } from 'antd';
import React from 'react';
import styled from 'styled-components';
import MyApplication from './MyApplication';
import MyCarousel from './MyCarousel';
import MyDeploy from './MyDeploy';
import MyEnv from './MyEnv';
import MyLibrary from './MyLibrary';
import MyTodo from './MyTodo';
import AddButton from './workflow/AddButton';
const Root = styled.div `
  margin: 16px;
  display: flex;
  justify-content: space-between;
  .ant-card-bordered {
    border: none;
  }
  .content-left {
    /* 这里给一个width，table就不会无限增长 */
    width: 20%;
    flex-grow: 1;
    margin-right: 16px;
    height: calc(100vh - 96px);
    overflow-y: scroll;
    background-color: #fff;
    .content-left-block {
      :first-child {
        max-height: 500px;
        border-bottom: 10px solid #f0f2f5;
      }
      background-color: #fff;
    }
  }
  .content-right {
    background-color: #fff;
    width: 420px;
    padding: 18px;
    height: calc(100vh - 96px);
    overflow-y: scroll;
  }
  .add-workflow-button {
    float: right;
    margin-top: -40px;
  }
`;
const { TabPane } = Tabs;
const Dashboard = ({ className, style }) => {
    return (<Root className={className} style={style}>
      <div className="content-left">
        <Card className="content-left-block">
          <Tabs>
            <TabPane tab="我的发布" key="1">
              <MyDeploy />
            </TabPane>
            <TabPane tab="我的环境" key="2">
              <MyEnv />
            </TabPane>
            <TabPane tab="我的应用" key="3">
              <MyApplication />
            </TabPane>
            <TabPane tab="我的二方库" key="4">
              <MyLibrary />
            </TabPane>
          </Tabs>
        </Card>
        <Card className="content-left-block">
          <div>
            <h1>我的待办</h1>
            {<AddButton className="add-workflow-button"/>}
            <MyTodo />
          </div>
        </Card>
      </div>
      <div className="content-right">
        <h2>公告栏</h2>
        <MyCarousel />
      </div>
    </Root>);
};
export default Dashboard;
